import {useEffect,useState} from 'react';

function read(uid,name,fallback) {
  try {const value=localStorage.getItem(`overview.${name}.v1.${uid}`);return value===null?fallback:value==='true';}catch{return fallback;}
}

export default function useOverviewBooleanPreference(uid,name,fallback) {
  const [state,setState]=useState(()=>({uid,value:read(uid,name,fallback)}));
  useEffect(()=>setState({uid,value:read(uid,name,fallback)}),[uid,name,fallback]);
  const value=state.uid===uid?state.value:fallback;
  const change=value=>{setState({uid,value});if(uid)try{localStorage.setItem(`overview.${name}.v1.${uid}`,String(value));}catch{}};
  return [value,change];
}
